module.exports = __webpack_public_path__ + "media/images/Wall-Background-Builder-11cca4616e98864b68b0c640a1155dd1.png";